module.exports = __webpack_public_path__ + "static/media/minimized.d369900d.svg";